import { Component, OnInit } from '@angular/core';
import { RepositoryService } from "../../shared/services/repository.service";
import { Risk } from "../../_interfaces/risk.model";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { RiskUser } from '../../_interfaces/RiskUser.model';
import { Department } from '../../_interfaces/Department.model';
import { formatDate } from '@angular/common';
import { RiskImpact, RiskProbability, RiskService } from 'src/app/shared/services/risk.service';
import { Observable } from 'rxjs';
import { HeadlineRisk } from 'src/app/_interfaces/HeadlineRisk.model';
import { RiskType } from 'src/app/_interfaces/RiskType.model';

@Component({
  selector: 'app-add-risk',
  templateUrl: './add-risk.component.html',
  styleUrls: ['./add-risk.component.css']
})

export class AddRiskComponent implements OnInit {
  riskDetail: Risk;
  riskAddForm: FormGroup;
  submitting = false;
  riskUsers: RiskUser[];
  departments: Department[];

  constructor(private formBuilder: FormBuilder,
    private repository: RepositoryService,
    private riskService: RiskService,
    private router: Router,
    private activeRoute: ActivatedRoute) {

    // this.getPeople();
  }

  ngOnInit() {

    this.riskDetail = new Risk();

    this.riskAddForm = this.formBuilder.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      cost: [0, [Validators.min(0)]],
      probability: ['', [Validators.required, Validators.min(0)]],
      alert: [false, Validators.required],
      impact: [50, [Validators.min(0)]],
      impactOutlook: [0, [Validators.min(-1)]],
      riskType: ['', Validators.required],
      financialRiskType: [''],
      strategicRiskType: [''],
      operationalRiskType: [''],
      //emergingRiskSegment: ['', Validators.required],
      emergingRiskProximity: ['', Validators.required],
      reviewAndUpdateDate: [''],
      riskOwnerId: ['', [Validators.required, Validators.min(0)]],
      riskManagerId: ['', [Validators.required, Validators.min(0)]],
      riskDepartmentId: ['', [Validators.required, Validators.min(0)]],
      reviewPeriod: ['', Validators.required],
      reviewDate: [''],

    });

    this.f.reviewDate.disable();

    this.getPeople();
    this.getDepartments();
  }


  get f() { return this.riskAddForm.controls; }

  get riskTypes$(): Observable<RiskType[]> {
    return this.riskService.riskTypes$;
  }

  get riskImpacts(): RiskImpact[] {
    return this.riskService.riskImpacts;
  }

  get riskProbabilites(): RiskProbability[] {
    return this.riskService.riskProbabilities;
  }

  public headlineRiskTypes$(riskType: number): Observable<HeadlineRisk[]> {
    return this.riskService.filterHeadlineRisks(riskType);
  }

  onCancelForm() {
    this.router.navigate([`/myrisks/list`]);
  }

  onSubmit() {
    this.submitting = true;

    if (this.riskAddForm.valid) {
      this.updateRiskFromForm();
      this.postRiskDetails();
      return;
    }

    this.riskAddForm.markAllAsTouched();

    this.submitting = false;
  }

  postRiskDetails() {
    let apiAddress: string = `Risks`;

    this.repository.create(apiAddress, this.riskDetail)
      .subscribe(res => {
          // this.riskDetail = res as Risk;
          //this.router.navigate(["../../risks"], { relativeTo: this.activeRoute });
          this.router.navigate([`/myrisks/list`]);
        }, error => {
          alert('Error:!' + error.message + '\n\n');
          this.router.navigate([`/myrisks/list`]);
        },
        () => this.router.navigate([`/myrisks/list`])
      );
  }

  updateRiskFromForm() {
    this.riskDetail.probability = +this.f.probability.value;
    
    this.riskDetail.alertLevel = +this.f.alert.value; 
    this.riskDetail.impact = +this.f.impact.value; // default to 'medium'
    this.riskDetail.impactOutlook = +this.f.impactOutlook.value; // default to 'stay same'
    this.riskDetail.riskType = +this.f.riskType.value;  
    this.riskDetail.financialRiskType = +this.f.financialRiskType.value; 
    this.riskDetail.strategicRiskType = +this.f.strategicRiskType.value; 
    this.riskDetail.operationalRiskType = +this.f.operationalRiskType.value; 
    
    

    //if (this.f.emergingRiskSegment.value) {
    //  this.riskDetail.emergingRiskSegment = + this.f.emergingRiskSegment.value;

    this.riskDetail.proximity = +this.f.emergingRiskProximity.value;
    this.riskDetail.owner = +this.f.riskOwnerId.value;
    this.riskDetail.lineManager = +this.f.riskManagerId.value;
    this.riskDetail.department = +this.f.riskDepartmentId.value;
    this.riskDetail.regulatoryDepartment = +this.f.riskDepartmentId.value;
    this.riskDetail.reviewPeriod = +this.f.reviewPeriod.value;
    
    
    this.riskDetail.nextReviewDate = this.f.reviewDate.value;

    // non-numeric fields
    this.riskDetail.title = this.f.title.value;
    this.riskDetail.description = this.f.description.value;
    this.riskDetail.mitigatingActions = "";
    this.riskDetail.riskStatus = 3; // Active Risk (i.e. not emerging risk)

    this.riskDetail.netCost = 0;
    this.riskDetail.id = 0;
    this.riskDetail.category = 1;
    this.riskDetail.regulatoryDepartment = 14; // Default
    this.riskDetail.netCost = 0;
    this.riskDetail.notes = ".";

    this.riskDetail.createdAt = new Date();
    this.riskDetail.updatedAt = new Date();
    this.riskDetail.global = 1;
  }

  public isActive = (element, index, array) => {
    return (element.dormant === 0);
  };

  public getPeople() {
    let apiAddress: string = `Users/UserList`; 
    this.repository.getData(apiAddress)
      .subscribe(res => {
        const riskUsers = res as RiskUser[];
        this.riskUsers = riskUsers.filter(this.isActive);
      });
  }

  public getDepartments() {
    let apiAddress: string = `Departments`; 
    this.repository.getData(apiAddress)
      .subscribe(res => {
        this.departments = res as Department[];
      });
  }

  public setReviewDateFromPeriod(period: number) {
    let reviewDate = new Date();
    let reviewDays = + period;

    reviewDate.setDate(reviewDate.getDate() + reviewDays);
    this.f.reviewDate.setValue(formatDate(reviewDate, 'yyyy-MM-dd', 'en'));
  }
  //
}
